import "../PermanentNotification.scss";

import React, { memo } from "react";
import { Link } from "react-router-dom";

interface SubscriptionNotificationProps {
  isOwner: boolean;
}

const SubscriptionNotification: React.FC<SubscriptionNotificationProps> = memo(
  ({ isOwner }) => {
    return (
      <div className="permanent-notification">
        <span>
          There is no active CogCache subscription.{" "}
          {isOwner && (
            <>
              Navigate to&nbsp;
              <Link
                className="permanent-notification__link"
                to="/organization/billing"
              >
                Billing
              </Link>
              &nbsp;page to learn more.
            </>
          )}
        </span>
      </div>
    );
  },
);

export { SubscriptionNotification };
